var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('section', {
    staticClass: "sub-visual"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap mb-24 mb-md-50 mb-lg-0"
  }, [_c('v-img', {
    staticClass: "tit-wrap__img",
    attrs: {
      "src": "/images/common/tit-img.png"
    }
  }), _c('h2', {
    staticClass: "tit tit--xl"
  }, [_vm._v(" Business ")])], 1)]), _c('v-img', {
    staticClass: "sub-visual__img",
    attrs: {
      "src": "/images/sub/business/sub-visual-business.jpg"
    }
  }), _c('sub-tab', {
    attrs: {
      "page": "비즈니스",
      "tabActive": 2
    }
  })], 1), _c('section', {
    staticClass: "sub-section sub-section--vnm"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "text-center text-md-left",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "pb-30 pb-md-44 pb-lg-60"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3"
    }
  }, [_c('v-card', {
    staticClass: "d-flex justify-center align-center rounded-pill ma-auto ma-md-0",
    attrs: {
      "flat": "",
      "width": "300",
      "height": "78",
      "color": "#32ABCA"
    }
  }, [_c('span', {
    staticClass: "white--text line-height-135 font-weight-bold font-size-32"
  }, [_vm._v("Vision")])])], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "9"
    }
  }, [_c('div', {
    staticClass: "ma-auto ma-md-0"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--xs"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v(" 모두를 위한 음식, 식자재 토탈 솔루션 ")])]), _c('p', {
    staticClass: "page-text font-weight-medium grey--text"
  }, [_vm._v(" 제 2의 도약을 위해 더욱 신뢰받고 책임있는 기업으로 나아가고자 합니다. ")])])])], 1)], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "pb-30 pb-md-44 pb-lg-60"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3"
    }
  }, [_c('v-card', {
    staticClass: "d-flex justify-center align-center rounded-pill ma-auto ma-md-0",
    attrs: {
      "flat": "",
      "width": "300",
      "height": "78",
      "color": "#277AB6"
    }
  }, [_c('span', {
    staticClass: "white--text line-height-135 font-weight-bold font-size-32"
  }, [_vm._v("Mission")])])], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "9"
    }
  }, [_c('div', {
    staticClass: "ma-auto ma-md-0"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--xs"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v(" 함께 할수있는 식문화를 널리 알리는 것 ")])]), _c('p', {
    staticClass: "page-text font-weight-medium grey--text"
  }, [_vm._v(" 좋은 사람과 좋은 분위기 속 맛있는 음식을 모두와 함께 즐기는 장소를 위해 더욱 유통에 부지런히 힘쓰는 것입니다. ")])])])], 1)], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "pb-30 pb-md-44 pb-lg-60"
  }, [_c('v-row', {
    staticClass: "align-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3"
    }
  }, [_c('v-card', {
    staticClass: "d-flex justify-center align-center rounded-pill ma-auto ma-md-0",
    attrs: {
      "flat": "",
      "width": "300",
      "height": "78",
      "color": "#BBCF62"
    }
  }, [_c('span', {
    staticClass: "white--text line-height-135 font-weight-bold font-size-32"
  }, [_vm._v("Goal setting")])])], 1), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "9"
    }
  }, [_c('div', {
    staticClass: "page-text font-weight-medium grey--text ma-auto ma-md-0"
  }, [_c('p', [_vm._v(" 2030년 까지 모두 에프엔티의 독자적인 프랜차이즈 브랜드 생성 ")]), _c('p', {
    staticClass: "mt-6 mt-md-8 mt-lg-12"
  }, [_vm._v(" 연매출 200억 이상 달성 목표 ")]), _c('p', {
    staticClass: "mt-6 mt-md-8 mt-lg-12"
  }, [_vm._v(" B2B 를 넘어 B2C 까지 종합 식자재 구매 쇼핑몰 구축 예정 ")])])])], 1)], 1)])], 1), _c('v-card', {
    staticClass: "mt-30 mt-md-44 mt-lg-60 py-50 py-md-74 py-lg-100 border",
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap-xs tit-wrap--center"
  }, [_c('h4', {
    staticClass: "tit font-pretendard line-height-135 mb-6 mb-md-8 mb-lg-12",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("(주) 모두 에프엔티의")]), _c('h3', {
    staticClass: "tit tit--lg",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v("PRINCIPLES")])]), _c('v-container', [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "max-width": "942",
      "data-aos": "fade-up",
      "data-aos-delay": "200",
      "src": "/images/sub/business/vnm/principles.png"
    }
  })], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section sub-section--competencies"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap tit-wrap--center"
  }, [_c('h3', {
    staticClass: "tit tit--lg"
  }, [_vm._v("핵심역량")])]), _c('v-row', {
    staticClass: "justfy-space-between"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-lg-start",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "core w-100"
  }, [_c('v-card', {
    staticClass: "white--text rounded-circle d-flex justify-center align-center w-100",
    attrs: {
      "flat": "",
      "img": "/images/sub/business/vnm/life-style.jpg"
    }
  }, [_c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--center tit-wrap--xs"
  }, [_c('p', {
    staticClass: "page-text page-text--xs"
  }, [_vm._v(" LIfe Style ")])]), _c('h3', {
    staticClass: "tit font-pretendard"
  }, [_vm._v(" #라이프 스타일 ")])])]), _c('p', {
    staticClass: "page-text mt-16 mt-md-24 mt-lg-32"
  }, [_vm._v(" 모두의 고객이 건강한 라이프스타일을 누릴 수 "), _c('br'), _vm._v(" 있도록 최상의 퀄리티의 서비스를 제공합니다. ")])], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "core w-100",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_c('v-card', {
    staticClass: "white--text rounded-circle d-flex justify-center align-center w-100",
    attrs: {
      "flat": "",
      "img": "/images/sub/business/vnm/trust.jpg"
    }
  }, [_c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--center tit-wrap--xs"
  }, [_c('p', {
    staticClass: "page-text page-text--xs"
  }, [_vm._v(" Trust ")])]), _c('h3', {
    staticClass: "tit font-pretendard"
  }, [_vm._v(" #신뢰 ")])])]), _c('p', {
    staticClass: "page-text mt-16 mt-md-24 mt-lg-32"
  }, [_vm._v(" 모두에프엔티는 합리적 가격과 정직한 상품으로"), _c('br'), _vm._v(" 고객과 함께 지속 가능한 미래를 그립니다. ")])], 1)]), _c('v-col', {
    staticClass: "ma-auto",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-lg-end",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, [_c('div', {
    staticClass: "core w-100"
  }, [_c('v-card', {
    staticClass: "white--text rounded-circle d-flex justify-center align-center w-100",
    attrs: {
      "flat": "",
      "img": "/images/sub/business/vnm/satisfaction.jpg"
    }
  }, [_c('div', [_c('div', {
    staticClass: "tit-wrap tit-wrap--center tit-wrap--xs"
  }, [_c('p', {
    staticClass: "page-text page-text--xs"
  }, [_vm._v(" Satisfaction ")])]), _c('h3', {
    staticClass: "tit font-pretendard"
  }, [_vm._v(" #고객만족 ")])])]), _c('p', {
    staticClass: "page-text mt-16 mt-md-24 mt-lg-32"
  }, [_vm._v(" 고객의 피드백을 발빠르게 반영하여"), _c('br'), _vm._v(" 만족도를 제공합니다. ")])], 1)])])], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }